import React from 'react';
import '../Styles/Logos.css';

export default function Logos() {
	return (
		<div className="logos-wrapper">
			<a className="logo-greenpeace-link" aria-label="Greenpeace website" rel="noreferrer" href="https://greenpeace.org/" target="_blank">
				<div className="logo"></div>
			</a>
		</div>
	);
}